// Coordinates are in the chart root's coordinate space, including axis zoom.
export function candleTooltipPlacement({ x, highY, lowY, bounds, height, width, fallbackY }) {
  const top = Math.min(highY, lowY), bottom = Math.max(highY, lowY);
  const visible = y => y >= bounds.top && y <= bounds.bottom;
  const gap = 9;
  if (visible(top) && top - height - gap >= bounds.top)
    return { pointTo: { x, y: top - 2 }, pointerOrientation: 'down' };
  if (visible(bottom) && bottom + height + gap <= bounds.bottom)
    return { pointTo: { x, y: bottom + 2 }, pointerOrientation: 'up' };
  // A visible end near the plot edge may leave no vertical room. Place the
  // card beside the candle rather than let the tooltip bounds push it over it.
  if (visible(top) || visible(bottom)) {
    const rightRoom = bounds.right - x, leftRoom = x - bounds.left;
    if (Math.max(rightRoom, leftRoom) >= width + gap)
      return { pointTo: { x, y: Math.max(bounds.top, Math.min(bounds.bottom, visible(top) ? top : bottom)) },
        pointerOrientation: rightRoom >= leftRoom ? 'left' : 'right' };
  }
  // Both ends are clipped (or the viewport cannot fit a card beside it).
  return { pointTo: { x, y: Math.max(bounds.top, Math.min(bounds.bottom, fallbackY)) }, pointerOrientation: 'vertical' };
}

export function configureCandleTooltipPlacement(tooltip, panel) {
  const original = tooltip._updateBackground;
  const update = () => {
    const item = tooltip.dataItem || tooltip.label.dataItem;
    const series = item?.component;
    if (!series?.getPoint || series.isDisposed?.()) return;
    const high = item.get('highValueY') ?? item.get('valueY');
    const low = item.get('lowValueY') ?? item.get('valueY');
    if (!Number.isFinite(high) || !Number.isFinite(low)) return;
    const xa = series.get('xAxis'), ya = series.get('yAxis');
    const x = xa.getDataItemPositionX(item, 'valueX', 0.5, 1);
    const highPoint = series.toGlobal(series.getPoint(x, ya.valueToPosition(high)));
    const lowPoint = series.toGlobal(series.getPoint(x, ya.valueToPosition(low)));
    const bounds = panel.plotContainer.globalBounds();
    const placement = candleTooltipPlacement({ x: highPoint.x, highY: highPoint.y, lowY: lowPoint.y,
      bounds, height: tooltip.height() || 100, width: tooltip.width() || 140,
      fallbackY: (bounds.top + bounds.bottom) / 2 });
    const old = tooltip.get('pointTo');
    if (!old || old.x !== placement.pointTo.x || old.y !== placement.pointTo.y)
      tooltip.set('pointTo', placement.pointTo);
    tooltip.set('pointerOrientation', placement.pointerOrientation);
    const previous = tooltip.get('bounds');
    if (!previous || Object.keys(bounds).some(k => previous[k] !== bounds[k])) tooltip.set('bounds', bounds);
  };
  tooltip._updateBackground = function () { update(); return original.call(this); };
  const listener = tooltip.root.events.on('frameended', () => {
    if (tooltip.isVisible() && !tooltip.isDisposed()) update();
  });
  tooltip.addDisposer(listener);
}
